module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--5--create-7d65acb4.jpg";